export default __webpack_public_path__ + "static/media/20.9fff1b1d.jpg";